import { Box, Button, Paper, Typography } from "@mui/material";
import React, { useEffect } from "react";
import Highcharts from "highcharts";
import Highcharts3D from "highcharts/highcharts-3d";
import HighchartsExporting from "highcharts/modules/exporting";
import HighchartsExportData from "highcharts/modules/export-data";
import NoRecordFound from "../../utils/NoRecordFound";
import { useNavigate } from "react-router-dom";

export const options = {
  pieHole: 0.4,
  is3D: false,
  legend: { position: "none" },
  colors: ["#3699FF", "#F64E60", "#0BB783"],
};

Highcharts3D(Highcharts);
HighchartsExporting(Highcharts);
HighchartsExportData(Highcharts);

const DonutChart = (Props) => {
  const handleViewChart2 = () => {
    Props.setIsFullScreenDonutchart(true);
  };

  useEffect(() => {
    const DonutChartData = {
      chart: {
        type: "pie",
        options3d: {
          enabled: true,
          alpha: 60,
        },
      },
      title: {
        text: "",
        align: "left",
      },
      exporting: false,
      subtitle: {
        text: "",
        align: "left",
      },
      tooltip: {
        pointFormat: " <b>{point.y}</b>",
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          innerSize: "50%", // Adjust the innerSize as per your preference
          depth: 45,
          dataLabels: {
            enabled: false,
          },
        },
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          data: [
            {
              name: "Open",
              y: Props?.data?.open_count,
              color: "#7A5DF8",
            },
            {
              name: "Closed",
              y: Props?.data?.close_count,
              color: "#F65464",
            },
            // {
            //   name: "In Progress",
            //   y: Props?.data?.in_progress_count,
            //   color: "#F65464",
            // },
          ],
        },
      ],
    };

    try {
      Highcharts.chart("DonutChart", DonutChartData);
    } catch (error) {
      console.error("Error initializing Highcharts:", error);
    }
  }, [Props.data]);

  const navigate = useNavigate();

  return (
    <>
      <Paper
        sx={{
          borderRadius: "12px",
        }}
      >
        <Box
          sx={{
            padding: "20px 20px 20px 20px",
            height: "45rem",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Typography
                sx={{ fontWeight: "600", fontSize: "17px", color: "#464E5F" }}
              >
                Defects Status
              </Typography>
              <Typography
                sx={{
                  fontWeight: "500",
                  fontSize: "12px",
                  color: "#B5B5C3",
                }}
              >
                {`Total ${Props?.data?.total} Defects`}
              </Typography>
            </Box>
            <Box>
              <Button
                disabled={Props.data && Props.data.total !== 0 ? false : true}
                sx={{
                  fontSize: "15px",
                  fontWeight: 600,
                  border: "1px solid #E5F1EB",
                  backgroundColor: "#E5F1EB",
                  padding: "8px 15px 5px 15px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#20724E",
                  ":hover": {
                    backgroundColor: "#E5F1EB",
                  },
                }}
                // onClick={() => setIsAddCompanyAdminMasterModel(true)}
                onClick={() => {
                  navigate("/defects");
                }}
              >
                view All
              </Button>
            </Box>
          </Box>
          <Box>
            {Props.data && Props.data.total !== 0 ? (
              <div
                id="DonutChart"
                style={{
                  width: "100%",
                  height: "400px",
                  "text.highcharts-credits": {
                    display: "none",
                  },
                }}
              ></div>
            ) : (
              <NoRecordFound />
            )}
          </Box>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gridGap: "20px",
            }}
          >
            {Props.data && Props.data.total !== 0 && (
              <>
                <Box
                  sx={{ cursor: 'pointer' }}
                  onClick={() => {
                    navigate("/defects", {
                      state: { DefectsOpen: "open" }
                    });
                  }}>
                  <Typography
                    sx={{
                      color: "#7A5DF8",
                      fontWeight: "600",
                      fontSize: "18px",
                    }}
                  >
                    {Props.data?.open_count}
                  </Typography>
                  <Typography>Open Defects</Typography>
                </Box>
                {/* <Box>
                  <Typography
                    sx={{
                      color: "#F64E60",
                      fontWeight: "600",
                      fontSize: "18px",
                    }}
                  >
                    {Props.data?.in_progress_count}
                  </Typography>
                  <Typography>In Progress Defect</Typography>
                </Box> */}
                <Box
                  sx={{ cursor: 'pointer' }}
                  onClick={() => {
                    navigate("/defects", {
                      state: { DefectsOpen: "close" }
                    });
                  }}>
                  <Typography
                    sx={{
                      color: "#F65464",
                      fontWeight: "600",
                      fontSize: "18px",
                    }}
                  >
                    {Props.data?.close_count}
                  </Typography>
                  <Typography>Closed Defects</Typography>
                </Box>
              </>
            )}
          </Box>
        </Box>
      </Paper>
    </>
  );
};

export default DonutChart;
